;(function () {
  angular.module('contrast.breadcrumbs-nav').constant('csBreadcrumbsNavTypes', {
    large: 'large',
    small: 'small'
  })
})()
